// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "3f7b14e5f9921d15","396": "175ce09b01e19532","460": "d3015d4be42d4181","498": "f9320259967c38f9","917": "8058b44cd51d3966","985": "9e5d50494978f160",}[chunkId] + ".chunk.js"
}